import { createContext, useContext } from 'react';

import type { ICircleSettingDetail } from '@/service/friend';

interface CircleChatContextType {
  route: string;
  circleDetail: ICircleSettingDetail | null;
  setCircleDetail: (
    data:
      | ICircleSettingDetail
      | null
      | ((prev: ICircleSettingDetail | null) => ICircleSettingDetail | null)
  ) => void;
}

const CircleChatContext = createContext<CircleChatContextType>({
  route: '',
  circleDetail: null,
  setCircleDetail: () => {}
});

export const useCircleChatContext = () => useContext(CircleChatContext);

export default CircleChatContext;
